import { html } from 'lit-html';
import { repeat } from 'lit-html/directives/repeat';
import { TilesVariantSelectorBase } from "./tiles-variant-selector-base.js";
import { IVariant } from './variant-selector-base.js';

export class RelImagesTilesVariantSelectorV1 extends TilesVariantSelectorBase {

    protected template = () => html`
        <div class="c-variant-selector__term-definition">
            <label class="c-variant-selector__label js-select-variant-label control-label">${this.variantSelectorData.variants.length > 1 ? this.variantSelectorData.labels.select : '' } ${this.variantSelectorData.variantTypeName}</label>
        </div>
        <div class="c-relimgtilesvariant__list">
        ${repeat(this.variantSelectorData.variants, (variant: IVariant) => html`
            <button type="button" class="c-relimgtilesvariant__option js-variant" data-variantid="${variant.id}">
                <figure class="c-relimgtilesvariant__image-container">
                ${variant.image
                    ? html`<img src="${variant.image.thumbnailUrl}" alt="${variant.image.title}" title="${variant.id}" class="c-relimgtilesvariant__image" width="${variant.image.thumbnailDisplayWidth}" height="${variant.image.thumbnailDisplayHeight}"/>`
                    : html`<img src="${this.variantSelectorData.defaultArchiveImage}" class="c-relimgtilesvariant__image" width="${this.variantSelectorData.thumbnailImage.width}" height="${this.variantSelectorData.thumbnailImage.height}"/>`
                }
                    <div class="c-relimgtilesvariant__unavailable-text js-unavailable-text-container" style="display:none;">
                        <span class="c-relimgtilesvariant__unavailable-text-label js-unavailable-text"></span>
                    </div>
                </figure>
                <div class="c-relimgtilesvariant__name">${variant.name}</div>
            </button>
        `)}
        </div>
    `;

    protected getDataBeforeRender() {
        const self = this;

        const result = {
            variantTypeName: this.variantType.name.toLowerCase(),
            variants: this.sortVariants(this.selectorContainerElement, this.variantType.variants, this.product),
            labels: { select: this.translations.get('selectVariantPrefix'), changeSelection: this.translations.get('changeSelectionVariantPrefix') },
            defaultArchiveImage: '\\viewimage.aspx?imageid=0&width=' + this.product.thumbnailImageWidth + '&' + this.product.thumbnailImageMode,
            thumbnailImage: {
                width: this.product.thumbnailImageWidth,
                height: this.product.thumbnailImageWidth
            }
        };

        if (this.product.relatedImages && this.product.relatedImages.length > 0) {
            result.variants.forEach(function (variant: any) {
                const variantName = typeof (variant.name.normalize) === 'function' ? variant.name.normalize() : variant.name;
                const variantNameRegex = RegExp(self.product.variantRelImageMatchRegExp.replace('VARIANTNAME', variantName), 'gi');

                var relatedImage = self.product.relatedImages.find(function (relImg) {
                    var imageName = typeof (relImg.title.normalize) === 'function' ? relImg.title.normalize() : relImg.title;
                    return variantNameRegex.test(imageName);
                });

                if (relatedImage) {
                    variant.image = relatedImage;
                }
            });
        }

        return result;
    }
}
